import React from 'react';

import {validateFieldDataFormat} from 'ultra/helpers/content';

import {useFormStore} from '../../../Stores/form';

import TextFieldInput from '../Text';

export default function Email(props) {
    const {setVisibleError} = useFormStore();

    const validateOnBlur = (e) => {
        const err = validateFieldDataFormat(props.field, props.content[props.field.id])
        // add this check on submit
        if (err) {
            setVisibleError(props.field.id, err);
        }
        else {
            props.onBlur(e);
        }
    }

    props.field.options = props.field.options || {};
    props.field.options.regexp = '^[0-9a-z\.\@\_]*$';;
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return <TextFieldInput {...props} inputMode="email" onBlur={validateOnBlur}/>
}
